<template>
  <Dialog
    ref="supportDocumentsDialog"
    dialog-mode="small"
    content-class="dialog-content support-docs !pt-0 !px-0"
    header-class="!py-4  gap-2 flex !justify-start align-center"
    footer-class="border-t border-solid border-[--color-neutral-a4] !justify-center"
  >
    <template #title>
      <span class="text-lg font-bold">{{ $t("pages.product.documents.support_documents") }}</span>
    </template>
    <template #content>
      <SupportDocuments v-if="selectedSupportDocumentsItemId" :product-code="selectedSupportDocumentsItemId" />
      <SupportDocuments
        v-if="selectedSupportDocumentsItem"
        :current-product="selectedSupportDocumentsItem as Product"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, onUnmounted } from "vue";
import { eventBus } from "@/shared/thorlabs/shared";
import type { Product, VariationTypeExtension } from "@/core/api/graphql/types";
import SupportDocuments from "@/shared/thorlabs/product-family/components/dialog/support-documents-dialog.vue";
import Dialog from "@/shared/thorlabs/shared/components/dialog-modal.vue";

const selectedSupportDocumentsItem = ref<Product | VariationTypeExtension | null>(null);
const selectedSupportDocumentsItemId = ref<string | null>(null);
const supportDocumentsDialog = ref<InstanceType<typeof Dialog> | null>(null);

eventBus.on("showSupportDocumentsDialog", (payload) => {
  selectedSupportDocumentsItemId.value = payload.itemId;
  selectedSupportDocumentsItem.value = null;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  supportDocumentsDialog.value?.openDialog();
});

eventBus.on("showSupportDocumentsDialog2", (payload) => {
  selectedSupportDocumentsItemId.value = null;
  selectedSupportDocumentsItem.value = { ...payload.product };
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  supportDocumentsDialog.value?.openDialog();
});

onUnmounted(() => {
  eventBus.off("showSupportDocumentsDialog");
  eventBus.off("showSupportDocumentsDialog2");
});
</script>

<style lang="scss">
.support-docs {
  .tl-support-documents {
    @apply border-0 #{!important};
    &__group-title {
      @apply text-base px-5 pb-2 border-b-0  mt-1 #{!important};
    }
    &__group-item {
      @apply px-5 py-2 text-base font-medium my-0 #{!important};
      &:not(.support-doc-inner) {
        @apply border-0 #{!important};
      }
      &.support-doc-inner {
        @apply border-b-0 #{!important};
      }
    }
    &__download {
      @apply mx-5;
    }
    &:has(.tl-support-documents__group-item + .tl-support-documents__group-title) {
      .tl-support-documents__group-title:not(:first-child) {
        @apply border-t #{!important};
      }
    }
  }
  .documents-tab {
    @apply pt-3 px-0 #{!important};
  }
  .compliance-tab {
    .compliance {
      @apply text-base border-0 #{!important};
      &__item {
        @apply px-0 border-0 #{!important};
      }
      &__email {
        @apply hidden;
      }
    }
  }
  .sds {
    &-tab {
      @apply text-base pt-2 #{!important};
    }

    @apply border-0 #{!important};
    &__item {
      @apply px-0 border-0 #{!important};
      span {
        @apply font-semibold #{!important};
      }
    }
  }
}
</style>
